import React from 'react';
import { Link } from 'react-router-dom';

function RenderGoalPlanData({
  data,
  addTreatmentGoal,
  deleteTreatmentGoal,
  eitableMode,
  resSetStatus,
  reviewExist,
}) {
  const goalPlanstatus = {
    1: 'In-progress',
    2: 'Completed',
    3: 'Closed',
    4: 'Deferred',
  };
  return (
    <div>
      {data &&
        data.map((item, i) => (
          <div key={i} className="cntnt-blk prgrs-vw-blk content-line-break">
            <div className="qcntnt-blk qprgrs-vw-blk">
              <div className="assmnt-nt-hdng">
                {eitableMode ? (
                  <span
                    className="hshtg-lnk goalLink"
                    onClick={() => addTreatmentGoal(item?.goalId, i)}
                  >
                    <Link>Goal #{i + 1}:</Link>
                  </span>
                ) : (
                  <span className="hshtg-lnk" style={{ fontSize: '1.5vw' }}>
                    Goal #{i + 1}:
                  </span>
                )}

                <span className="clear-left maroon common-fontsize">
                  Added: {item?.goalAddedDate}
                </span>

                {eitableMode ? (
                  <span className="right clear-left">
                    {(reviewExist === '1' || resSetStatus === '3') && (
                      <span
                        className="hshtg-lnk goalLink"
                        onClick={() => addTreatmentGoal(item?.goalId, i)}
                      >
                        <Link
                          className="bold common-fontsize"
                          style={{ marginRight: '25px' }}
                        >
                          [Add Review]
                        </Link>
                      </span>
                    )}
                    <span
                      className="hshtg-lnk goalLink"
                      onClick={() => deleteTreatmentGoal(item?.goalId, i)}
                    >
                      <Link className="red bold common-fontsize">Delete</Link>
                    </span>
                  </span>
                ) : (
                  <span className="hshtg-lnk"></span>
                )}
              </div>
              <div className="assmnt-nt-rw med-value clear-bottom qfontsize14">
                <span dangerouslySetInnerHTML={{ __html: item?.goalDetail }} />
              </div>
              {item?.objArr.map((obj, j) => (
                <div
                  key={j}
                  className="width100 clear-bottom"
                  style={{ borderBottom: '0px dotted orange' }}
                >
                  <div className="assmnt-nt-sbhdng">
                    <span className="assmnt-nt-rw tp-chld-hdng orange-txt">
                      Objective #{j + 1}:
                    </span>
                    <span className="assmnt-nt-rw normal">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: obj?.objDetail,
                        }}
                      />
                    </span>
                    <span className="tp-status-rw">
                      <span className="normal sec-colr width100">
                        Added: {obj?.objAddedDate}
                      </span>
                      <span className="normal clear-right clear-left sec-colr width100 ">
                        Status: {goalPlanstatus[obj?.objStatus]}
                      </span>
                      <span className="normal clear-right clear-left sec-colr width100">
                        Completion:&nbsp;
                        <span
                          dangerouslySetInnerHTML={{
                            __html: obj?.completionDate,
                          }}
                        />
                      </span>
                    </span>
                  </div>
                  {obj?.interDetailArr.map((inter, k) => (
                    <div key={k} className="assmnt-nt-sbhdng">
                      <span className="left tp-chld-hdng orange-txt">
                        Intervention #{k + 1}
                      </span>

                      <span className="assmnt-nt-rw normal">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: inter?.intervention_title,
                          }}
                        />
                      </span>
                      <span className="tp-status-rw">
                        <span className="normal maroon">
                          Added: {inter?.addedDateIntervention}
                        </span>
                      </span>
                    </div>
                  ))}
                  {obj?.reviewDetailArr.map((rev, l) => (
                    <div key={l} className="assmnt-nt-sbhdng">
                      <span className="left tp-chld-hdng orange-txt">
                        Review #{l + 1}
                      </span>

                      <span className="assmnt-nt-rw normal">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: rev?.review_title,
                          }}
                        />
                      </span>
                      <span className="tp-status-rw">
                        <span className="normal maroon">
                          Added: {rev?.addedDateReview}
                        </span>
                      </span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}

export default RenderGoalPlanData;
